import React from "react";

function CollectionCard(props) {
  const {
    coverImage,
    className = "d-item col-lg-3 col-md-6 col-sm-6 col-xs-12 mb-4",
    profileImage,
    name,
    handleCollectionClick = () => {},
    style,
  } = props;
  return (
    <div className={className} style={style}>
      <div className="nft_coll" style={{ padding: "0.6rem" }}>
        <div
          className="nft_wrap"
          style={{ cursor: "pointer", borderRadius: "0.6rem" }}
          onClick={handleCollectionClick}
        >
          <span>
            {coverImage ? (
              <img
                src={coverImage}
                className="lazy img-fluid"
                alt=""
                style={{ height: 160, width: "100%" }}
              />
            ) : (
              <div className="no-img-wrapper"></div>
            )}
          </span>
        </div>
        <div className="nft_coll_pp" onClick={handleCollectionClick}>
          {profileImage ? (
            <img
              className="lazy"
              src={profileImage}
              alt=""
              style={{
                height: "70px",
                width: "70px",
                border: 0,
              }}
            />
          ) : (
            <div className="no-img-wrapper">
              {name && name[0].toUpperCase()}
            </div>
          )}
        </div>
        <div className="nft_coll_info">
          <span onClick={handleCollectionClick}>
            <h4 id="limit-content-length">{name}</h4>
          </span>
        </div>
      </div>
    </div>
  );
}

export default CollectionCard;
